module.exports = __webpack_public_path__ + "static/media/notification-icon.34a2f3ed.svg";